import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable, throwError  } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'src/app/services/utils';
import { COMMON_CONSTANTS, ERROR_CATEGORY} from '../common/core/common.constants';
import { APIGEE_TOKEN_URL } from '../common/core/urls.constants';
import { HelperUtilityService } from './helper-utility.service';
import { HttpCacheService } from './http-cache.service';
import { UtilsService } from './utils.service';
import * as DeviceDetector from 'device-detector-js';
export interface ILogLoad {
    requestPayload: any;
    ban: any;
    userId: any;
}

@Injectable()
export class HttpLoggingInterceptor implements HttpInterceptor {

    private authReq: HttpRequest<any>;
    DiffreqUrl: any;
    startTime: any;
    diffTime: any;
    endTime: any;
    cookiesVal: any;
    private LOG_LEVEL = ['TRACE', 'DEBUG', 'INFO', 'LOG', 'WARN', 'ERROR', 'OFF'];
    parsedRequest: any;
    requestDate: any;
    b2bRequestid: any;
    redFlag = false;
    requestBody: any;
    ResponseBody: any;
    constructor(private utils: UtilsService, private _helperUtiSvc: HelperUtilityService,
                private _cacheSvc: HttpCacheService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        this.authReq = req;
        if (req.url.indexOf(APIGEE_TOKEN_URL.SPLUNK_LOG.path) === -1) {
            this.DiffreqUrl = req.url ;
            this.startTime = new Date().getTime();
        }
        // inject this method thorugh service
        if (req.url.indexOf(APIGEE_TOKEN_URL.SPLUNK_LOG.path) !== -1) {
            const parsedReq =  req.body;
            if (isNullOrUndefined(parsedReq.errorType)) {
                const respUrl =   req.body.url;
                if (respUrl.indexOf(this.DiffreqUrl) > -1) {
                    this.endTime = new Date().getTime();
                    this.diffTime =  (this.endTime - this.startTime) / 1000;
                    sessionStorage.setItem(COMMON_CONSTANTS.DIFFTIME_KEY, this.diffTime);
                }
            }
            this.authReq = this._mapLoggingPayload(req);
            return next.handle(this.authReq).pipe(
                map((event) => {
                    return event;
                }),
                catchError((error) => {
                    return throwError(error);
            }));

        }
        return next.handle(this.authReq);
    }
    _mapLoggingPayload(req: HttpRequest<any>): HttpRequest<any> {

        let submitCall = '';
        let flowType = '';
        let apiName = '';
        let redFlagCheck = '';
        const euiToken =
        '{"customerFirstName":"test-AccoutMgt","customerLastName":"test-AccoutMgt","customerPhone":"1111111111","logonId":"test@test.com"}';
        // tslint:disable-next-line:one-variable-per-declaration
        let errorCategory, errorCode, errorMessage ;
        this.parsedRequest =  req.body;
        this.requestBody =  this.parsedRequest.requestBody;
        this.ResponseBody = this.parsedRequest.body;

            if (isNullOrUndefined(this.parsedRequest.errorType)) {

            if (!isNullOrUndefined(this.parsedRequest.error) && (!isNullOrUndefined(this.parsedRequest.error.error)
                || !isNullOrUndefined(this.parsedRequest.error.errors))) {
                if (('error' in this.parsedRequest) && ('error' in this.parsedRequest.error) &&
                this.parsedRequest.error.error.length > 0) {
                errorCode = this.parsedRequest.error.error[0].code;
                errorMessage = this.parsedRequest.error.error[0].userMessage;
                if (this.parsedRequest.status !== ERROR_CATEGORY.HTTP_STATUS) {
                        errorCategory = ERROR_CATEGORY.FAILURE_SYSTEM_VALIDATION;
                    } else if (this.parsedRequest.status === ERROR_CATEGORY.HTTP_STATUS) {
                        errorCategory = ERROR_CATEGORY.FAILURE_BUSINESS_VALIDATION;
                    }
                } else if (('error' in this.parsedRequest) && ('errors' in this.parsedRequest.error) &&
                    ('error' in this.parsedRequest.error.errors) && this.parsedRequest.error.errors.error.length > 0) {
                    errorCode = this.parsedRequest.error.errors.error[0].code;
                    errorMessage = this.parsedRequest.error.errors.error[0].userMessage;
                    if (this.parsedRequest.status !== ERROR_CATEGORY.HTTP_STATUS) {
                        errorCategory = ERROR_CATEGORY.FAILURE_SYSTEM_VALIDATION;
                    } else if (this.parsedRequest.status === ERROR_CATEGORY.HTTP_STATUS) {
                        errorCategory = ERROR_CATEGORY.FAILURE_BUSINESS_VALIDATION;
                    }
                } else if (('error' in this.parsedRequest) && ('errors' in this.parsedRequest.error) &&
                    this.parsedRequest.error.errors.length > 0) {
                    errorCode = this.parsedRequest.error.errors[0].code;
                    errorMessage = !isNullOrUndefined(this.parsedRequest.error.errors[0].systemMessage) ?
                        this.parsedRequest.error.errors[0].systemMessage : this.parsedRequest.error.errors[0].userMessage ;
                    if (this.parsedRequest.status !== ERROR_CATEGORY.HTTP_STATUS) {
                        errorCategory = ERROR_CATEGORY.FAILURE_SYSTEM_VALIDATION;
                    } else if (this.parsedRequest.status === ERROR_CATEGORY.HTTP_STATUS) {
                        errorCategory = ERROR_CATEGORY.FAILURE_BUSINESS_VALIDATION;
                    }
                } else {
                    errorCategory = ERROR_CATEGORY.FAILURE_SYSTEM_VALIDATION;
                }
            } else if (!isNullOrUndefined(this.parsedRequest.error) && isNullOrUndefined(this.parsedRequest.error.error)) {
                errorCategory = ERROR_CATEGORY.FAILURE_SYSTEM_VALIDATION;
            }

            const headerObj = {
                'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
                'Host': window.document.location.host,
                'Origin': window.document.location.origin,
                'Referer': window.document.location.href,
                'User-Agent': navigator.userAgent,
                'Cookie': COMMON_CONSTANTS.SPLUNK_PROPERTIES.ADRUM + '=' + this.utils.getCookie(COMMON_CONSTANTS.SPLUNK_PROPERTIES.ADRUM),
            };

            const reqMessgae = _.get(req, 'body.message', '{}');
            const reqParsed = reqMessgae;
            submitCall = _.get(reqParsed , COMMON_CONSTANTS.SPLUNK_PROPERTIES.SUBMIT_CALL , false);
            flowType = _.get(reqParsed , COMMON_CONSTANTS.SPLUNK_PROPERTIES.FLOW_TYPE , false);
            redFlagCheck = _.get(reqParsed , COMMON_CONSTANTS.SPLUNK_PROPERTIES.REDFLAG, false);
            apiName = _.get(reqParsed , COMMON_CONSTANTS.SPLUNK_PROPERTIES.API_NAME , '');
            this.b2bRequestid = _.get(reqParsed , COMMON_CONSTANTS.SPLUNK_PROPERTIES.B2BREQUESTID , '');
            this.requestDate =  _.get(reqParsed , COMMON_CONSTANTS.SPLUNK_PROPERTIES.REQUEST_DATE , '');
            const headerResponseObj = {
                'b2b-requestid': this.b2bRequestid,
                'date': this.requestDate

            };

            if (redFlagCheck && ( req.body.status !== 200)) {
                this.redFlag = true;
            } else {
                this.redFlag = false;
            }

                this.authReq = req.clone({
                    withCredentials: true,
                    body: {
                        event: {
                            'ban': this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY),
                            'userId': _.get(JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)
                                || euiToken), 'logonId', ''),
                            'severity': this.LOG_LEVEL[req.body.level],
                            'Log_Type': COMMON_CONSTANTS.SPLUNK_PROPERTIES.SERVER_SIDE_LOG,
                            'Error_category': errorCategory,
                            'Error_Code': errorCode,
                            'Error_Message': errorMessage,
                            'appId': environment.APP_ID,
                            'environment': environment.ENV,
                            'url':  req.body.url,
                            'status':  req.body.status,
                            'timestamp': Date().toLocaleString(),
                            'request': { body: this.requestBody, header: headerObj },
                            'response': {
                                body: !isNullOrUndefined(this.parsedRequest.body) ?
                                    // tslint:disable-next-line:align
                                    this.ResponseBody : this.parsedRequest.error, header: headerResponseObj
                            },
                            'response_time': sessionStorage.getItem(COMMON_CONSTANTS.DIFFTIME_KEY),
                            'transactionID': sessionStorage.getItem(COMMON_CONSTANTS.TRANSACTIONID),
                            'authType': this._helperUtiSvc.getAuthType(),
                            'b2b-requestid': headerResponseObj['b2b-requestid'],
                            'submitCall': submitCall,
                            'redFlag': this.redFlag,
                            'flowType': flowType,
                            'apiName': apiName,
                            'paramUID': this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.QUERY_PARAM_UID),
                            'clientDetails': this.getDeviceDetails()
                        },
                        index: 'duck'},
            });
        } else if (!isNullOrUndefined(this.parsedRequest.errorType) &&
           (this.parsedRequest.errorType  === COMMON_CONSTANTS.SPLUNK_CLIENTSIDE_ERROR ||
            this.parsedRequest.errorType  === COMMON_CONSTANTS.HIT_A_SNAG)){

            this.authReq = req.clone({
                withCredentials: true,
                body: {
                    event: {
                        ban: this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY),
                        userId: _.get(JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)
                            || euiToken), 'logonId', ''),
                        Log_Type: this.parsedRequest.errorType,
                        Error_category: this.parsedRequest.errorType,
                        Error_Message : this.parsedRequest.requestBody,
                        appId: environment.APP_ID,
                        environment: environment.ENV,
                        timestamp : Date().toLocaleString(),
                        transactionID: sessionStorage.getItem(COMMON_CONSTANTS.TRANSACTIONID),

                    },
                    index: 'duck'},
            });
        }
        this.splunkMasking(this.authReq,  req.body.url);
        return this.authReq;
    }
    splunkMasking(message: HttpRequest<any>, apiUrl? : string) {
        let event = message.body.event;
        let messageString = JSON.stringify(event, function (key, value) {
            let valuesTobeMasked = COMMON_CONSTANTS.MASKING_INFORMATION;
            let maskedValue = value;
            valuesTobeMasked?.forEach((data) => {
                if (data.name == key && typeof value == 'string' && !!value) {
                    switch (data.type) {
                        case COMMON_CONSTANTS.LAST_4:
                            maskedValue = maskedValue?.replace(/.(?=.{4,}$)/g, '*');
                            break;
                        case COMMON_CONSTANTS.COMPLETE:
                            maskedValue = maskedValue?.replace(/./g, '*');
                            break;
                        case COMMON_CONSTANTS.TOTAL:
                            maskedValue = '****';
                            break;
                        default:
                            break;
                    }
                }
            });
            return maskedValue;
        });
        message.body.event = JSON.parse(messageString);
    }


    getDeviceDetails() {
        const deviceDetector = new DeviceDetector();
        return deviceDetector.parse(navigator.userAgent);
    }

    // getHeaderFromParsedRequest(req ,headerName){
    //   let headerValue = '';
    //   if(!isNullOrUndefined(req.headers && req.headers.headers)){
    //     const reqHeaders = req.headers.headers;
    //     reqHeaders.forEach((item)=>{
    //       if(item[COMMON_CONSTANTS.DIGITS.ZERO] == headerName){
    //         headerValue = item[COMMON_CONSTANTS.DIGITS.ONE][COMMON_CONSTANTS.DIGITS.ZERO];
    //       }
    //     })
    //   }
    //   return headerValue;
    // }


}
